import Constants from '../actions/types';

const initialState = {
  message: null,
  error: null
};

const operationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.OPERATION_ASSIGN_GLOBALID_SUCCESS: {
      const newState = {
        ...state,
        message:
          'Successfully initiated the job to assign global identifiers in job ' +
          action.payload.jobEntryId
      };

      return newState;
    }

    case Constants.OPERATION_ASSIGN_GLOBALID_FAILURE: {
      const newState = {
        ...state,
        error: action.payload
      };

      return newState;
    }

    case Constants.OPERATION_CREATE_ENTITYINDXS_SUCCESS: {
      const newState = {
        ...state,
        message:
          'Successfully initiated the job to create entity indexes in job ' +
          action.payload.jobEntryId
      };

      return newState;
    }

    case Constants.OPERATION_CREATE_ENTITYIDXS_FAILURE: {
      const newState = {
        ...state,
        error: action.payload
      };

      return newState;
    }

    case Constants.OPERATION_DROP_ENTITYINDXS_SUCCESS: {
      const newState = {
        ...state,
        message:
          'Successfully initiated the job to drop entity indexes in job ' +
          action.payload.jobEntryId
      };

      return newState;
    }

    case Constants.OPERATION_DROP_ENTITYINDXS_FAILURE: {
      const newState = {
        ...state,
        error: action.payload
      };

      return newState;
    }

    case Constants.OPERATION_REMOVE_GLOBALID_SUCCESS: {
      const newState = {
        ...state,
        message:
          'Successfully initiated the job to remove global identifiers in job ' +
          action.payload.jobEntryId
      };

      return newState;
    }

    case Constants.OPERATION_REMOVE_GLOBALID_FAILURE: {
      const newState = {
        ...state,
        error: action.payload
      };

      return newState;
    }

    case Constants.OPERATION_START_PIXPDQ_SUCCESS: {
      const newState = {
        ...state,
        message: 'Successfully started the PIX/PDQ Server '
      };

      return newState;
    }

    case Constants.OPERATION_START_PIXPDQ_FAILURE: {
      const newState = {
        ...state,
        error: action.payload
      };

      return newState;
    }

    case Constants.OPERATION_STOP_PIXPDQ_SUCCESS: {
      const newState = {
        ...state,
        message: 'Successfully stopped the PIX/PDQ Server'
      };

      return newState;
    }

    case Constants.OPERATION_STOP_PIXPDQ_FAILURE: {
      const newState = {
        ...state,
        error: action.payload
      };

      return newState;
    }

    case Constants.OPERATIONS_CLEAR_ERROR: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};

export default operationsReducer;
